<script>

export default {
  translate25Context: 'troubleshooting',
  methods: {},
  props: ["handler", "instance"],
  data() {
    return {
    };
  },
  async mounted() {
  }
}
</script>

<template>
  <div class="troubleshooting-player">
    <troubleshooting-page :title="$vt('Encoder prerequises')">
      <template #content>

        <div class="list">
          <div class="title">{{$vt('Domains')}}</div>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_encoder:api'].component.vnginx.http"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_encoder:api'].component.vnginx.rtmp"></troubleshooting-page-http-status>

          <span class="troubleshooting-encoder-wowzas"
            v-for="wowza in instance['troubleshooting_encoder:api'].component.wowzas" :key="wowza['#id']">

            <troubleshooting-page-http-status :component="wowza.http"></troubleshooting-page-http-status>

            <troubleshooting-page-webRTC-status :component="wowza.rtmp"></troubleshooting-page-webRTC-status>

          </span>

        </div>

        <div class="bandwith list">
          <div class="title">{{$vt('Network requirement')}}</div>
          <troubleshooting-bandwith
            :component="instance['troubleshooting_encoder:api'].component.bandwith"></troubleshooting-bandwith>
        </div>

        <div class="encoding list">
          <div class="title">{{$vt('Encoding prerequises')}}</div>
          <div class="item">
            <span class="name"></f-icon>{{$vt('Resolution')}}</span>
            <span class="value">{{$vt('1080p : 1920x1080')}}</span>
          </div>
          <div class="item">
            <span class="name"></f-icon>{{$vt('Bandwith')}}</span>
            <span class="value">{{$vt('3Mbs/s (cbr)')}}</span>
          </div>
          <div class="item">
            <span class="name"></f-icon>{{$vt('Framerate')}}</span>
            <span class="value">{{$vt('30fps, keyframe 1sec')}}</span>
          </div>
          <div class="item">
            <span class="name"></f-icon>{{$vt('Video encoding')}}</span>
            <span class="value">{{$vt('H264 High Profile')}}</span>
          </div>
          <div class="item">
            <span class="name"></f-icon>{{$vt('Audio encoding')}}</span>
            <span class="value">{{$vt('AAC 128Kpbs')}}</span>
          </div>

        </div>

      </template>
    </troubleshooting-page>
  </div>
</template>

<style lang="scss">
.troubleshooting-player {
  width: 100%;
  height: 100%;
  overflow: auto;

  .troubleshooting-encoder-wowzas {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .encoding {
    .item {

      display: flex;
      flex-direction: column;

      .name {}

      .value {
        font-weight: 700;
      }
    }
  }
}
</style>